import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "input"]

  connect() {
    this.updateSection()
  }

  toggle() {
    this.updateSection()
  }

  updateSection() {
    const show = this.shouldShowDetails()
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.toggle("hidden", !show)
    }
    if (this.hasInputTarget) {
      this.inputTarget.required = show
    }
  }

  shouldShowDetails() {
    const checked = this.element.querySelector("input[type='radio'][name$='[played_for_other_club_last_year]']:checked")
    if (!checked) return false

    const value = checked.value
    return value === "true" || value === "1"
  }
}
